import { render, staticRenderFns } from "./SSOPage.vue?vue&type=template&id=d72b2956"
import script from "./SSOPage.vue?vue&type=script&lang=js"
export * from "./SSOPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports